export const getTotalGuestsQtyFromHotelOccupationArray = hotelOccupation => {
  return hotelOccupation.reduce((acc, _ref) => {
    let {
      adults,
      children
    } = _ref;
    return acc + adults + children;
  }, 0);
};